import React from 'react';

import { HowItWorks } from '../HowItWorks';
import { ReferHosts } from '../ReferHosts';
import { CreditsBalance } from './CreditsBalance';
import { RenterHeading } from './RenterHeading';

export const RenterPage = () => {
  return (
    <>
      <RenterHeading />
      <HowItWorks />
      <CreditsBalance />
      <ReferHosts />
    </>
  );
};
